import { ApolloConsumer } from '@apollo/client'
import { SuspenseWithLoading } from '@salescore/client-common'
import {
  closeGlobalLauncher,
  openGlobalLauncher,
  selectGlobalLauncherIsOpen,
  useAppDispatch,
  useAppSelector,
} from '@salescore/client-redux'
import { wrapKeyboardEvent } from '@salescore/frontend-common'
import { type KeyboardEvent, type ReactElement, useCallback, useEffect } from 'react'

import { LauncherBodyV2 } from './LauncherBodyV2'

export function GlobalLauncher(): ReactElement {
  const isLauncherOpen = useAppSelector(selectGlobalLauncherIsOpen)
  const dispatch = useAppDispatch()
  const openLauncher = useCallback(() => {
    dispatch(openGlobalLauncher())
  }, [dispatch])
  const closeLauncher = useCallback(() => {
    dispatch(closeGlobalLauncher())
  }, [dispatch])

  useEffect(() => {
    const handler = (event: unknown): void => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion,sonarjs/todo-tag
      const e = event as KeyboardEvent<HTMLDivElement> // TODO
      const wrapped = wrapKeyboardEvent(e)
      if (wrapped.key === 'k' && wrapped.commandKey) {
        openLauncher()
        e.preventDefault()
      }
      if (wrapped.code === 'Escape') {
        closeLauncher()
        e.preventDefault()
      }
    }
    globalThis.addEventListener('keydown', handler)
    return (): void => {
      globalThis.removeEventListener('keydown', handler)
    }
  }, [openLauncher, closeLauncher])

  // エラー表示などを出したくないのでhandleQueryは使わない
  if (!isLauncherOpen) {
    return <></>
  }

  return (
    <ApolloConsumer>
      {(client) => (
        <SuspenseWithLoading>
          <LauncherBodyV2 closeLauncher={closeLauncher} />
        </SuspenseWithLoading>
      )}
    </ApolloConsumer>
  )
}
